import React from 'react';
import { Bug } from 'lucide-react';

const ST22Wizard = ({ data, setData }) => {
  const options = [
    { id: 'explainCause',        label: 'Explicar Causa Raíz',          desc: 'Análisis detallado del origen del dump' },
    { id: 'suggestFix',          label: 'Generar Código Correctivo',     desc: 'Código ABAP listo para aplicar el fix' },
    { id: 'preventiveMeasures',  label: 'Medidas Preventivas (TRY-CATCH)', desc: 'Manejo de excepciones para evitar recurrencia' },
    { id: 'technicalNote',       label: 'Generar Nota para Soporte',     desc: 'Documento técnico para SAP Support' },
  ];

  return (
    <div className="animate-in fade-in slide-in-from-top-4 duration-500 text-left space-y-6">

      {/* NOTA */}
      <div className="bg-red-900/10 border-l-4 border-red-600 p-5 rounded-r-3xl flex gap-4 items-start">
        <div className="bg-red-600 p-2 rounded-xl text-white shrink-0">
          <Bug size={18} />
        </div>
        <div>
          <p className="text-[11px] text-red-400 font-black uppercase tracking-widest mb-1">
            ST22 Runtime Analysis Guide
          </p>
          <p className="text-[11px] text-slate-400 leading-relaxed">
            Ingresá el ID del dump de ST22 y el programa afectado. El motor analiza 
            la causa raíz del <strong>Short Dump</strong>, genera el código correctivo 
            con manejo de excepciones y produce documentación técnica para soporte SAP.
          </p>
        </div>
      </div>

      <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">

        {/* COLUMNA 1 */}
        <div className="bg-[#0F172A] p-6 rounded-[28px] text-white border-b-4 border-red-500 space-y-4">
          <label className="text-[10px] font-black text-red-400 uppercase flex items-center gap-2 border-b border-slate-800 pb-2">
            <Bug size={14}/> Datos del Dump
          </label>

          <div>
            <label className="text-[9px] font-bold text-slate-400 uppercase block mb-1">
              ID del Error (ST22 Dump ID)
            </label>
            <input
              type="text"
              className="w-full p-2.5 bg-slate-800 border border-slate-700 rounded-xl text-xs font-mono text-red-300 placeholder:text-slate-600 outline-none focus:border-red-400 uppercase"
              placeholder="Ej: DATA_OFFSET_NEGATIVE"
              value={data.dumpErrorId || ''}
              onChange={(e) => setData({...data, dumpErrorId: e.target.value})}
            />
          </div>

          <div>
            <label className="text-[9px] font-bold text-slate-400 uppercase block mb-1">
              Programa / Objeto Afectado
            </label>
            <input
              type="text"
              className="w-full p-2.5 bg-slate-800 border border-slate-700 rounded-xl text-xs font-mono text-white placeholder:text-slate-600 outline-none focus:border-red-400"
              placeholder="Ej: ZCL_HANDLER=======CP"
              value={data.dumpProgram || ''}
              onChange={(e) => setData({...data, dumpProgram: e.target.value})}
            />
          </div>

          <div>
            <label className="text-[9px] font-bold text-slate-400 uppercase block mb-1">
              Tipo de Objeto
            </label>
            <select
              className="w-full p-2.5 bg-slate-800 border-none rounded-xl text-xs font-bold text-white outline-none focus:ring-2 focus:ring-red-500"
              value={data.dumpObjectType || 'PROG'}
              onChange={(e) => setData({...data, dumpObjectType: e.target.value})}
            >
              <option value="PROG">Programa ABAP (PROG)</option>
              <option value="CLASS">Clase Local/Global (CLASS)</option>
              <option value="FUNC">Módulo de Función (FUNC)</option>
              <option value="METH">Método de Clase (METH)</option>
              <option value="BADI">BAdI Implementation</option>
              <option value="FORM">Subrutina FORM</option>
            </select>
          </div>
        </div>

        {/* COLUMNA 2 */}
        <div className="bg-[#0F172A] p-6 rounded-[28px] text-white border-b-4 border-red-500 space-y-4">
          <label className="text-[10px] font-black text-red-400 uppercase flex items-center gap-2 border-b border-slate-800 pb-2">
            <Bug size={14}/> Análisis Requerido
          </label>

          <div className="space-y-3">
            {options.map((opt) => (
              <button
                key={opt.id}
                onClick={() => setData({
                  ...data,
                  dumpOptions: { ...data.dumpOptions, [opt.id]: !data.dumpOptions?.[opt.id] }
                })}
                className={`w-full flex items-center gap-3 p-3 rounded-xl border transition-all text-left ${
                  data.dumpOptions?.[opt.id]
                    ? 'bg-red-600/20 border-red-500/50'
                    : 'bg-slate-800 border-slate-700 hover:border-slate-600'
                }`}
              >
                <div className={`w-2 h-2 rounded-full shrink-0 ${data.dumpOptions?.[opt.id] ? 'bg-red-400 animate-pulse' : 'bg-slate-600'}`} />
                <div className="flex-1">
                  <p className={`text-[10px] font-black uppercase ${data.dumpOptions?.[opt.id] ? 'text-red-400' : 'text-slate-400'}`}>
                    {opt.label}
                  </p>
                  <p className="text-[9px] text-slate-500">{opt.desc}</p>
                </div>
              </button>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default ST22Wizard;